export default "__VITE_ASSET__CKPgVCqi__"